module.exports = __webpack_public_path__ + "img/skip-arrow.e245ea67.svg";